import { ReactNode } from "react";

import { classNames } from "@helpers/css";

import {
  addLevelTitleColClassName,
  emptyRoleColWidth,
  roleColWidth,
  roleLevelIterator,
  stickyColWidth,
} from "../helpers";
import StickyColumnShadow from "../sticky-column-shadow";

// Section title cells stick just below the pinned level header row while
// their section scrolls by. Collapsed borders don't move with sticky cells, so
// the bottom line is drawn as a shadow and the real one hidden (hidden wins).
const stickyTitleCellClassName =
  "sticky z-[15] shadow-[inset_0_-1px_0_#e5e7eb] [border-bottom-style:hidden]";

const TitleRow = ({
  levelCount,
  levels = roleLevelIterator(levelCount),
  title,
  toneClassName = "bg-gray-50",
  roleLevels,
  action,
  stickyTop,
}: {
  levelCount: number;
  // The level columns shown, when not all of them are.
  levels?: number[];
  title: string;
  // Background and text colour saying how far the section reaches.
  toneClassName?: string;
  roleLevels: number[];
  action?: ReactNode;
  // Height of the pinned header row above, in px.
  stickyTop: number;
}) => {
  const stickyStyle = { top: stickyTop };
  return (
    <tr className="border-t border-b">
      <td
        className={classNames(
          stickyColWidth,
          stickyTitleCellClassName,
          "px-4 py-2 font-bold left-0 z-[16]",
          toneClassName,
        )}
        style={stickyStyle}
      >
        <div className="flex items-center justify-between gap-2 min-w-0">
          {/* A long section name is cut rather than wrapped, so every header
              row keeps the same height; the full name is in the tooltip. */}
          <div className="flex items-center gap-2 min-w-0">
            <div className="truncate" title={title}>
              {title}
            </div>
          </div>
          <div className="shrink-0 flex items-center">{action}</div>
        </div>
        <StickyColumnShadow />
      </td>
      {levels.map((level) => {
        const roleExists = roleLevels.includes(level);
        return (
          <td
            className={classNames(
              roleExists && roleColWidth,
              !roleExists && emptyRoleColWidth,
              "border",
              toneClassName,
              stickyTitleCellClassName,
            )}
            style={stickyStyle}
            key={level}
          ></td>
        );
      })}
      <td
        className={classNames(
          addLevelTitleColClassName,
          toneClassName,
          stickyTitleCellClassName,
        )}
        style={stickyStyle}
      />
    </tr>
  );
};

export default TitleRow;
